import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Container, Card, CardBody, Button } from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import {  getRecords} from "../../../services/api.service.js";
import "react-toastify/dist/ReactToastify.css";
import { basicFormData, createPageData } from "./CategoryFile.js";
import {formContentContainer, loaderOverlay} from "../../../Style/loaderOverly.js";
import { AvForm } from "availity-reactstrap-validation";
import { LoaderCreatePage } from "../../Loader/Loader.js";
import formatDateTime from "../../../custom/Utils/formatDateTime.js";
const CategoryView = () => {

  const { id } = useParams();
  const navigate = useNavigate();

  const { payload, navigatePage, getEndpoint } = createPageData();

  const initialPayload = useMemo(() => payload, []);
  const [loadingData, setLoadingData] = useState(id ? true : false);
  const [formData, setFormData] = useState(basicFormData());
  
  useEffect(() => {
    if (id) {
      getEditData(id);
    }
  }, [id]);

  

  const getEditData = async (id) => {

    try {
      let payload = {
        modelName: initialPayload?.modelName,
        schema: initialPayload?.schema,
        whereCondition: { id: id, is_active: true }
      };

      const responseData = await getRecords(payload, getEndpoint);

      if (responseData?.data && responseData.data.length > 0) {
        const data = responseData.data[0];
        setFormData({inputData:data})
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div style={formContentContainer}>
                    <AvForm className="needs-validation">
                      <div className="card mt-4">
                        <div className="card-header">
                          <h5>Category Details</h5>
                          <Button
                            color="secondary"
                            className="waves-effect waves-light me-1 back-button"
                            onClick={() => navigate(navigatePage?.back)}
                          >
                            Back
                          </Button>
                        </div>
                        <div className="card-body">
                          <Row>
                            {/* First Section (Left Side) */}
                            <Col
                              md="6"
                              className="border-end border-secondary p-3"
                            >

                              <p>
                                <strong>Type: </strong>
                                {formData?.inputData?.type === 0
                                  ? "Material"
                                  : "Sparepart" || "-"}
                              </p>
                              <p>
                                <strong>Category: </strong>
                                {formData?.inputData?.name ||
                                  "-"}
                              </p>

                              <p>
                                <strong>Category Description: </strong>
                                {formData?.inputData?.descriptions ||
                                  "-"}
                              </p>
                              
                            </Col>
                            {/* Second Section (Right Side) */}
                            <Col md="6" className="p-3">
                              

                              <p>
                                <strong>Status: </strong>
                                {formData?.inputData?.is_active === true
                                  ? "ACTIVE"
                                  : "IN-ACTIVE" || "-"}
                              </p>
                              <p>
                                <strong>Created At: </strong>
                                {formData?.inputData?.createdAt === null ? "NA" : formatDateTime(formData?.inputData?.createdAt)}
                              </p>

                              <p>
                                <strong>Updated At: </strong>
                                {formData?.inputData?.updatedAt === null ? "NA" : formatDateTime(formData?.inputData?.updatedAt)}
                              </p>
                            </Col>
                          </Row>
                        </div>
                      </div>
                      
                    </AvForm>

                    {/* Loader Overlay */}
                    {loadingData && (
                      <div style={loaderOverlay}>
                        <LoaderCreatePage />
                      </div>
                    )}
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default CategoryView;
